export default __webpack_public_path__ + "static/media/twitter.e8b83be6.png";